export const notifySuccessfulVehicleExit = (updateResponse, expectedStayId, onCreatedRecord) => {
  const responseStayId = Number(updateResponse?.data?.id);
  const selectedStayId = Number(expectedStayId);
  if (!Number.isInteger(responseStayId) || responseStayId <= 0 || responseStayId !== selectedStayId) {
    throw new Error('La respuesta de salida no contiene el ID esperado de la estadía.');
  }
  onCreatedRecord?.('Estadias', responseStayId, 'salida');
  return responseStayId;
};
